import React from 'react';
import './Rules.css';

const Rules = () => {
  return (
    <div className="rules">
      <div className="rules-container">
        <h1>Competition Format</h1>
        <h2>3/10 - 5/30</h2>
        <h3>Provide a competitive environment to encourage a healthy lifestyle</h3>
        <div className="rules-content">
          <ul>
            <li>Track scores daily and total them up weekly</li>
            <li>12 week duration</li>
            <li>Honor system</li>
            <li>Winner gets free domestic airfare as approved by the awards committee</li>
            <li>Additional incentives to be provided be the awards committee including consistency of participation</li>
            <li>Will iterate and improve - don't let the great get in the way of the good</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Rules;
